import { AssetsService } from '@coosmo/shared-utils'

export default {
  showStepContent: function (storyboard) {
    document.getElementById('viewer').classList.remove('away')
    storyboard.DOM.stepContentWidget.classList.remove('away')
    storyboard.DOM.stepContentToggle.classList.remove('away')
    storyboard.DOM.stepTextWrapper.classList.remove('away')
    storyboard.DOM.toolbar.classList.remove('away')
    storyboard.DOM.toggleStepContentButton.src = AssetsService.getSvgIcon('prev-grey.svg')
    storyboard.DOM.stepContentWidget.style.opacity = '0.9'
    storyboard.DOM.stepContentToggle.style.opacity = '0.9'
  },
  hideStepContent: function (storyboard, makeInvisible) {
    document.getElementById('viewer').classList.add('away')
    storyboard.DOM.stepContentWidget.classList.add('away')
    storyboard.DOM.stepContentToggle.classList.add('away')
    storyboard.DOM.stepTextWrapper.classList.add('away')
    storyboard.DOM.toolbar.classList.add('away')
    storyboard.DOM.toggleStepContentButton.src = AssetsService.getSvgIcon('next-grey.svg')
    if (makeInvisible) {
      storyboard.DOM.stepContentWidget.style.opacity = '0'
      storyboard.DOM.stepContentToggle.style.opacity = '0'
    }
  }
}
